import React from 'react';

/**
 * 예약현황(투어딜) 컴포넌트
 */
function ReservationInfo() {
  const {
    htDealInfo: {
      categoryInfo: { verticalType },
    },
    htDealContentInfo: {
      contentInfo: { reservationUrl },
    },
  } = TMON.oApp.htStorage.htStaticData;

  const goReservation = () => {
    // 모앱일 경우 콜앱 호출
    if (TMON.oApp.sPlatform === 'MA') {
      TMON.app.callApp(
        'webview',
        'showNaviWebView',
        '티몬',
        TMON.util.aup(reservationUrl, TMON.sAppQuery),
        false, // isModal
        false, // isNeedLogin
        true // isNeedNavigation
      );
      return;
    }

    window.open(reservationUrl, '_blank');
  };

  return (
    verticalType &&
    verticalType === 'TOUR' &&
    reservationUrl && (
      <div className="deal_info_unit">
        <div className="info_unit_title">
          <h3 className="title">예약현황</h3>
        </div>
        <div className="info_unit_contents">
          <div
            className="info_unit_button"
            role="button"
            onClick={goReservation}
          >
            <p>예약현황 보기</p>
          </div>
        </div>
      </div>
    )
  );
}

export default ReservationInfo;
